import type { EmailCountsDTO } from '@hearth/shared';
import { useQuery } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';
import { api } from '../../lib/api';
import { BulkEmailPage } from '../campaigns/BulkEmailPage';
import { CampaignDetailPage, CampaignsPage } from '../campaigns/CampaignsPage';
import { EmailPage } from './EmailPage';

export const routes: RouteObject[] = [
  { path: '/email', element: <EmailPage /> },
  { path: '/email/bulk', element: <BulkEmailPage /> },
  { path: '/email/campaigns', element: <CampaignsPage /> },
  { path: '/email/campaigns/:id', element: <CampaignDetailPage /> },
];

/** Sidebar badge: emails waiting on a human (approval or a delivery problem). */
export function useNavCount(): number | undefined {
  const { data } = useQuery({
    queryKey: ['emails', 'counts'],
    queryFn: ({ signal }) => api.get<EmailCountsDTO>('/api/emails/counts', { signal }),
    staleTime: 60_000,
    select: (counts) => counts.approval + counts.needsAttention,
  });
  return data;
}
